function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.205 22a2.057 2.057 0 002.051-2.051h-4.102A2.05 2.05 0 0012.205 22zm6.154-6.154v-5.128c0-3.149-1.682-5.785-4.615-6.482v-.698c0-.85-.688-1.538-1.539-1.538s-1.538.687-1.538 1.538v.698c-2.944.697-4.616 3.323-4.616 6.482v5.128L4 17.897v1.026h16.41v-1.026l-2.051-2.05z",
  fill: "#FFF"
});

function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
}

export default SvgAlert;